import { useState } from "react";
import email from "../../assets/email.svg";
import phone from "../../assets/phone.svg";
import instagram from "../../assets/instagram.svg";
import whatsapp from "../../assets/whatsapp.svg";
import logo from "../../assets/logo.svg";
import "./style.css";

const Navbar = () => {
	const [isActive, setIsActive] = useState("Home");
	const [isOpen, setIsOpen] = useState(false);

	const toggleNavbar = () => setIsOpen(!isOpen);
	const closeNavbar = () => setIsOpen(false);

	return (
		<nav>
			<div className="topnavbar">
				<div className="email-phone">
					<div className="email">
						<img src={email} alt="email" />
						<a
							href="mailto:info@fm90valet.com"
							target="_blank"
							rel="noreferrer">
							<span>info@fm90valet.com</span>
						</a>
					</div>
					<div className="phone">
						<img src={phone} alt="phone" />
						<a href="tel:+96590068722" target="_blank" rel="noreferrer">
							<span>(965) 9006-8722</span>
						</a>
					</div>
				</div>
				<div className="social">
					<a
						href="https://www.instagram.com/fm90_valet_parking?igsh=MTkxYjdoOHM4OWptYQ=="
						target="_blank"
						rel="noreferrer">
						<img src={instagram} alt="instagram" />
					</a>
					<a href="https://wa.me/+96590068722" target="_blank" rel="noreferrer">
						<img src={whatsapp} alt="youtube" />
					</a>
				</div>
			</div>
			<div className="navbar">
				<div className="nav-logo">
					<img src={logo} alt="logo" />
				</div>

				<div className="navbar-expand-lg">
					<div className="container-fluid">
						<button
							className="navbar-toggler"
							type="button"
							onClick={toggleNavbar}
							data-bs-toggle="collapse"
							data-bs-target="#navbarNavAltMarkup"
							aria-controls="navbarNavAltMarkup"
							aria-expanded="false"
							aria-label="Toggle navigation">
							<span className="navbar-toggler-icon"></span>
						</button>
						<div
							className={`collapse navbar-collapse ${isOpen ? "show" : ""}`}
							id="navbarNavAltMarkup">
							<div className="navbar-nav">
								<div>
									<a
										href="#Home"
										onClick={() => {
											setIsActive("Home");
											closeNavbar();
										}}
										className={
											isActive === "Home" ? "active nav-link" : "nav-link"
										}
										aria-current="page">
										Home
									</a>
									<a
										href="#About"
										onClick={() => {
											setIsActive("About");
											closeNavbar();
										}}
										className={
											isActive === "About" ? "active nav-link" : "nav-link"
										}
										aria-current="page">
										About
									</a>
									<a
										href="#Features"
										onClick={() => {
											setIsActive("Features");
											closeNavbar();
										}}
										className={
											isActive === "Features" ? "active nav-link" : "nav-link"
										}
										aria-current="page">
										Features
									</a>
								</div>
								<div>
									<a
										href="#Screenshot"
										onClick={() => {
											setIsActive("Screenshot");
											closeNavbar();
										}}
										className={
											isActive === "Screenshot" ? "active nav-link" : "nav-link"
										}
										aria-current="page">
										Screenshot
									</a>
									<a
										href="#Privacy"
										onClick={() => {
											setIsActive("Privacy");
											closeNavbar();
										}}
										className={
											isActive === "Privacy" ? "active nav-link" : "nav-link"
										}
										aria-current="page">
										Privacy
									</a>
									<a
										href="#Download"
										onClick={() => {
											setIsActive("Download");
											closeNavbar();
										}}
										className="download"
										aria-current="page">
										Download
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</nav>
	);
};
export default Navbar;
